import AppState from './AppState';
import merge from 'deepmerge';
import i18n from 'i18next';

import AuthService from 'lib/AuthService';

import localStore from 'lib/LocalStore';

const Auth = new AuthService();

const Map = obj => merge({}, obj);

class AppHandlers extends AppState {

	// User handlers
	logoutHandler = () => {
	  const { language } = i18n;
	  this.setState({
	    buildings: [],
	    brochures: [],
	    users: [],
	    user: {
	      data: null,
	      open: false
	    }
	  });

	  Auth.logout();

	  this.props.history.replace(`/${language}/t/login/`);
	}

	collectionOpenHandler = open => this.setState(state => {
	  const collectionsOpen = typeof open === 'boolean' ? open : !state.collectionsOpen;

	  return { collectionsOpen };
	});

	collectionSelectHandler = collection => this.setState({ collection });

	collectionHandler = collection => this.setState(state => {
	  const collections = JSON.parse(JSON.stringify(this.state.collections));
	  const collectionIndex = collections.findIndex(c => c.id === collection.id);

	  if (collectionIndex === -1) {
	    collections.splice(0, 0, collection);
	  } else {
	    collections[collectionIndex] = collection;
	  }

	  return {
	    collections,
	  }
	});

	removeCollectionHandler = collectionId => this.setState(state => {
	  const collections = JSON.parse(JSON.stringify(this.state.collections));
	  const collectionIndex = collections.findIndex(c => c.id === collectionId);

	  if (collectionIndex !== -1) {
	    collections.splice(collectionIndex, 1);
	  }

	  return {
	    collections,
	  }
	});

	changeBrochureTypeHandler = brochureType => this.setState(state => {
	  localStore.set({ brochureType });

	  return { brochureType };
	});

	// Browse handlers
	changeBrowseTypeHandler = browseType => this.setState(state => {
	  const browse = Map(state.browse);

	  browse.type = browseType;

	  localStore.set({ browseType });

	  return { browse };
	});

	browseSortChangeHandler = event => {
	  event.persist();

	  this.setState(state => {
	    const browse = Map(state.browse);
	    const browseSort = event.target.value;

	    browse.sort = browseSort;

	    localStore.set({ browseSort });

	    return { browse };
	  })
	};

	filterOpenHandler = id => this.setState(state => {
	  const newState = {
	    user: Map(state.user),
	    browse: Map(state.browse),
	  };

	  newState.user.open = false;

	  for(let filterId in newState.browse.filters) {
	    if (filterId !== id) {
	      newState.browse.filters[filterId].open = false;
	    }
	  }

	  newState.browse.filters[id].open = !state.browse.filters[id].open;

	  return newState;
	});

	filterCheckHandler = (id, option) => this.setState(state => {
	  const { language } = i18n;

	  const browse = Map(state.browse);

	  const filterData = browse.filters[id];
	  const options = language in filterData.options ? filterData.options[language] : filterData.options;
	  const optionData = options[option];

	  optionData.selected = !optionData.selected;

	  filterData.hasSelected = false;

	  options.forEach(option => {
	    filterData.hasSelected = filterData.hasSelected || option.selected;
	  });

	  if (optionData.selected) {
	    browse.activeFilters.push({
	      type: id,
	      ...optionData
	    });
	  } else {
	    const filterIndex = browse.activeFilters.findIndex(filter => { return filter.type === id && filter.value === optionData.value });

	    browse.activeFilters.splice(filterIndex, 1);
	  }

	  return { browse };
	});

	filterRangeHandler = (key, value) => {
	  const browse = Map(this.state.browse);
	  const subKey = key.substr(0,3);

	  browse.filters.area.range[key] = value;

	  if (key === 'min' || key === 'max') {
	    browse.filters.area.range[key + 'Selected'] = true;
	  }

	  browse.filters.area.hasSelected = browse.filters.area.range.minSelected || browse.filters.area.range.maxSelected;

	  if (browse.filters.area.hasSelected) {
	    const tagIndex = browse.activeFilters.findIndex(tag => tag.type === 'area' && tag.key === subKey);

	    if (browse.filters.area.range[subKey + 'Selected']) {
	      const value = browse.filters.area.range[subKey];
	      const char = subKey === 'min' ? '>' : '<';
	      const name = char + ' ' + value + 'm²';

	      if (tagIndex > -1) {
	        browse.activeFilters[tagIndex].value = value;
	        browse.activeFilters[tagIndex].name = name
	      } else {
	        browse.activeFilters.push({
	          type: 'area',
	          key: subKey,
	          name,
	          value,
	        });
	      }
	    } else {
	      browse.activeFilters.splice(tagIndex, 1);
	    }
	  } else {
	    const tagIndex = browse.activeFilters.findIndex(tag => tag.type === 'area');
	    browse.activeFilters.splice(tagIndex, 1);
	  }

	  this.setState({ browse });
	}

	textSearchHandler = search => {
	  this.setState(state => {

	    const browse = Map(state.browse);

	    browse.activeFilters.push({
	      type: 'text',
	      name: search,
	      value: search
	    });

	    return { browse };
	  });
	}

	toggleOnlyShowFreeHandler = () => {
	  this.setState(state => {
	    const browse = Map(state.browse);

	    browse.onlyShowBuildingsWithFreeSpaces = !browse.onlyShowBuildingsWithFreeSpaces;

	    return { browse };
	  });
	}

	removeFilterTagHandler = index => this.setState(state => {
	  const language = localStore.get('language');
	  const browse = Map(state.browse);

	  const filter = browse.activeFilters[index];

	  if (['contact', 'city', 'spaceType', 'region'].includes(filter.type)) {
	    const filterOptions = language in browse.filters[filter.type].options ? browse.filters[filter.type].options[language] : browse.filters[filter.type].options;
	    const optionIndex = filterOptions.findIndex(option => option.value === filter.value);

	    filterOptions[optionIndex].selected = false;
	    browse.filters[filter.type].hasSelected = filterOptions.findIndex(option => option.selected) > -1;
	  }

	  if (filter.type === 'area') {
	    const resetValues = {
	      min: Math.min.apply(999999, this.state.buildings.map(b => b.minArea)),
	      max: Math.max.apply(0, this.state.buildings.map(b => b.maxArea)),
	    };

	    browse.filters.area.range[filter.key + 'Selected'] = false;
	    browse.filters.area.hasSelected = browse.filters.area.range.minSelected || browse.filters.area.range.maxSelected;

	    browse.filters.area.range[filter.key] = resetValues[filter.key];
	  }

	  browse.activeFilters.splice(index, 1);

	  return { browse };
	});

	updateBuildingHandler = data => this.setState(state => {
	  const buildings = Map(state.buildings);
	  const buildingIndex = buildings.findIndex(building => building.slug === data.slug);

	  if (data.spaces) {
	    data.spaces = data.spaces.filter(space => space.slug !== '').map(bspace => {
	      const spaceData = this.state.spaces.find(space => space.slug === bspace);

	      return spaceData ? spaceData : bspace;
	    }).filter(space => {
	      const valid = typeof space !== 'string';

	      return valid;
	    });
	  }

	  if (buildingIndex === -1) {
	    buildings.push(data);
	  } else {
	    buildings[buildingIndex] = {
	      ...buildings[buildingIndex],
	      ...data
	    };
	  }

	  return { buildings }
	})

	// Update brochure from editor
	updateBrochureHandler = brochure => this.setState(state => {
	  // Map building from buildings
	  if (brochure !== null) {
	    const building = this.state.buildings.find(building => building.slug === brochure.building);

	    brochure.mappedBuilding = building;
	  }

	  return { brochure }
	});

	togglePageListHandler = pageListOpen => this.setState({
	  controlsOpen: false,
	  pageListOpen: typeof pageListOpen !== 'undefined' ? pageListOpen : !this.state.pageListOpen
	});

	// Set Editor controls panel open or closed. Toggles current value if no parameter set.
	toggleControlsHandler = controlsOpen => this.setState(state => ({
	  activeSlot: null,
	  controlsOpen: typeof controlsOpen !== 'undefined'
	    ? controlsOpen
	    : state.activeSlot !== null
	      ? true
	      : !state.controlsOpen
	}));

	activeSlotHandler = activeSlot => this.setState({ activeSlot });

	toggleGeneratePdfOpen = generatePDFOpen => this.setState({
	  generatePDFOpen: typeof generatePDFOpen !== 'undefined' ? generatePDFOpen : !this.state.generatePDFOpen
	});
}

export default AppHandlers
